import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=82637488&scoped=true&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&id=82637488&prod&scoped=true&lang=css&"
import style1 from "./Culture.vue?vue&type=style&index=1&id=82637488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82637488",
  null
  
)

export default component.exports